import React from 'react';

import CheckedSvg from 'assets/svg-icons/style-checked.svg?react';

import { deleteObjectField } from 'utils';
import classnames from 'classnames';
import { useCheckDisabledAddDeletePermission } from './hooks';

import PermissionButton from './PermissionButton';

const PermissionTypeIcon = (props) => {
  const { type, permitData, formRole } = props;

  const { checkDisabledAddDeletePermissionBtn } =
    useCheckDisabledAddDeletePermission();

  const isDisabledBtn = checkDisabledAddDeletePermissionBtn(
    permitData?.permissionName
  );

  const handleClickAdd = () => {
    let nextPermitData = { ...permitData };
    deleteObjectField(nextPermitData, ['isNew']);
    let nextPermissions = [...formRole?.values?.permissions, nextPermitData];
    formRole.setFieldValue('permissions', nextPermissions);
  };

  const handleClickRemove = () => {
    let nextPermissions = [...formRole?.values?.permissions];
    const findPermitIndex = nextPermissions.findIndex(
      (permit) => permit?.permissionName === permitData?.permissionName
    );
    nextPermissions.splice(findPermitIndex, 1);
    formRole.setFieldValue('permissions', nextPermissions);
  };

  return (
    <div
      className={classnames('role-permission-group__list-item-icon', {
        'role-permission-group__list-item-icon--disabled': !type,
      })}
    >
      {type === 'add' ? (
        <PermissionButton
          type={'add'}
          disabled={isDisabledBtn}
          onClick={handleClickAdd}
        />
      ) : type === 'remove' ? (
        <PermissionButton
          type={'remove'}
          disabled={isDisabledBtn}
          onClick={handleClickRemove}
        />
      ) : (
        <CheckedSvg />
      )}
    </div>
  );
};

export default PermissionTypeIcon;
